export default __webpack_public_path__ + "static/media/mobileErrorImage.cac85e34.svg";